export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <linearGradient id="fscdTeal" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#14B8A6" />
          <stop offset="0.55" stopColor="#0F766E" />
          <stop offset="1" stopColor="#134E4A" />
        </linearGradient>
        <linearGradient id="fscdAmber" x1="26" y1="24" x2="38" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FDE68A" />
          <stop offset="1" stopColor="#F59E0B" />
        </linearGradient>
        <radialGradient id="fscdGlow" cx="0.35" cy="0.3" r="0.9">
          <stop offset="0" stopColor="#5EEAD4" stopOpacity="0.55" />
          <stop offset="1" stopColor="#5EEAD4" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="19" fill="url(#fscdTeal)" />
      <rect x="2" y="2" width="60" height="60" rx="19" fill="url(#fscdGlow)" />
      <rect x="3.25" y="3.25" width="57.5" height="57.5" rx="17.75" stroke="#FFFFFF" strokeOpacity="0.25" strokeWidth="2.5" />
      {/* sun rays */}
      {Array.from({ length: 8 }).map((_, i) => {
        const a = (i * Math.PI) / 4 - Math.PI / 2;
        const x1 = 32 + Math.cos(a) * 12.5, y1 = 30 + Math.sin(a) * 12.5;
        const x2 = 32 + Math.cos(a) * 16, y2 = 30 + Math.sin(a) * 16;
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#FCD34D" strokeWidth="2.4" strokeLinecap="round" opacity="0.9" />;
      })}
      {/* eye */}
      <path d="M14 30 Q32 15 50 30 Q32 45 14 30 Z" fill="#FFFFFF" fillOpacity="0.12" stroke="#FFFFFF" strokeWidth="3" strokeLinejoin="round" />
      {/* iris = rising sun */}
      <circle cx="32" cy="30" r="8" fill="url(#fscdAmber)" />
      <circle cx="32" cy="30" r="3.4" fill="#134E4A" />
      <circle cx="29.6" cy="27.6" r="1.5" fill="#FFFFFF" fillOpacity="0.85" />
      {/* sprouting leaves / community hands */}
      <path d="M20 50 Q32 42 44 50" stroke="#5EEAD4" strokeWidth="3.2" strokeLinecap="round" fill="none" />
      <path d="M32 46.5 C28.5 43.5 28.5 39.5 32 37.5 C35.5 39.5 35.5 43.5 32 46.5 Z" fill="#FCD34D" />
    </svg>
  );
}

export default function Logo({ size = 40, dark = false, sub = "Foundation for Sustainable Community Development", title = "FSCD Global Skills" }) {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark size={size} className="drop-shadow-md" />
      <span className="leading-tight">
        <span className={`block font-heading font-extrabold tracking-tight ${dark ? "text-white" : "text-teal-950"}`} style={{ fontSize: size * 0.42 }}>
          FSCD <span className="text-amber-500">Global</span> Skills
        </span>
        {sub && <span className={`block text-[9px] uppercase tracking-[0.14em] ${dark ? "text-teal-200/80" : "text-teal-700/70"}`}>{sub}</span>}
      </span>
    </span>
  );
}
